<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      <!-- 复合搜索框 -->
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`已送达运单`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #orderNum="params">
        <div class="orderNum" :class="params.params.is_reject == 1 ? 'tui' : ''">
          {{ params.params.order_num }}
        </div>
      </template>
      <template slot="btn1" slot-scope="params">
        <el-button class="positionbtn" type="primary" @click="showPosition(params.params)" size="mini">位置</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        ischeck: 1,
        isstatus: 3,
      },
      formCtrl: [],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150, slot: 'orderNum' },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "", label: "位置", slot: 'btn1' },
      ],
      btns: [
        {
          class: 'dispatchbtn',
          title: '再派一单',
          img: require('@/assets/img/icon-paidan.png'),
          unimg: require('@/assets/img/icon-paidan-hover.png'),
          cb: ({ id }) => {
            this.$router.push(`/order/nocontractadd?id=${id}`)
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/nocontractview3?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id }) => {
            // console.log(id)
            this.$router.push(
              `/order/nocontractfee?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: this.delete,
      })
    }
    if ([2, 3, 4].includes(user_group_id)) {
      // 财务不能查看位置
      this.cols.splice(this.cols.length - 1, 1)
      // 财务能查看运单详情和费用详情
      const feebtn = this.btns[2]
      this.btns = [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/nocontractview2?id=${id}&mode=view`
            );
          },
        },
        feebtn,
      ]
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .table-wrap {
    .el-table {
      .orderNum {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tui {
        position: relative;

        &::after {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../../../../assets/img/icon_reject.png) no-repeat center center;
          background-size: 20px;
        }
      }
    }
  }
}
</style>
